export enum HeroBannerType {
  V1 = 'herobannerv1',
  V2 = 'herobannerv2',
  V3 = 'herobannerv3',
  V4 = 'herobannerv4',
}
